import React, { useState, useContext, useEffect } from 'react';
import ViewsContext from 'contexts/viewsContext';
import HourlySalesChartGlance from './hourlySalesChartGlance';
import HourlySalesTableViewGlance from './hourlySalesTableViewGlance';




export default function ToggleHourlySalesGlance(props) {

    const { viewsState, setHourlySalesToggleState } = useContext(ViewsContext);
    const [chartToggleClass, setChartToggleClass] = useState('');
    const [tableViewToggleClass, setTableViewToggleClass] = useState('');

    useEffect(() => {
        if (viewsState.chartsAndTableViewsConfigs.hourlySalesToggleState === 'chart') {
            setTableViewToggleClass('togglable-hidden');
            setChartToggleClass('');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlySalesToggleState === 'tableView') {
            setChartToggleClass('togglable-hidden');
            setTableViewToggleClass('');
        }

    }, [viewsState]);

    const changeView = () => {
        if (viewsState.chartsAndTableViewsConfigs.hourlySalesToggleState === 'chart') {
            setHourlySalesToggleState('tableView');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlySalesToggleState === 'tableView') {
            setHourlySalesToggleState('chart');
        }
    };

    if (viewsState.chartsAndTableViewsConfigs.hourlySalesToggleState === 'chart') {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlySalesChartGlance data={props.data} viewState={chartToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlySalesTableViewGlance data={props.data} viewState={tableViewToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }

}

